import { createContext, Dispatch, SetStateAction } from "react";

import { FormInstance } from "antd";
import { SelectOption } from "../../../../../../../../shared/interfaces";
import { StepTwoFormFields } from "./StepTwoFormProvider";
import { PLAN_TYPE } from "../../../../shared";

interface StepTwoFormContextProps {

    stepTwoForm:                          FormInstance<any> | undefined;

    activeKey:                            any;
    setActiveKey:                         Dispatch<SetStateAction<any>>;

    tabs:                                 Array<any>;
    setTabs:                              Dispatch<SetStateAction<Array<any>>>;
    addNewTab:                            (id?: number) => void;
    duplicateTab:                         (id: number) => void;
    removeTab:                            (id?: any) => void;

    theftInsuranceFormValues:             StepTwoFormFields | null;
    setTheftInsuranceFormValues:          Dispatch<SetStateAction<StepTwoFormFields | null>>;

    showModal:                            boolean;
    setShowModal:                         Dispatch<SetStateAction<boolean>>;
    
    keyTabToDelete:                       number | null;
    setKeyTabToDelete:                    Dispatch<SetStateAction<number | null>>;

    planOptionsBySelectedPlan:            Array<SelectOption>;

    areTabActionsAllowed:                 boolean;
    planTypeSelected:                     PLAN_TYPE;
    setPlanTypeSelected:                  Dispatch<SetStateAction<PLAN_TYPE>>;
    resetTabs:                            (unconfirmedPlanType: PLAN_TYPE) => void;

    isPlanTypeADisabled:                  boolean;
    setIsPlanTypeADisabled:               Dispatch<SetStateAction<boolean>>;

    isPlanTypeCDisabled:                  boolean;
    setIsPlanTypeCDisabled:               Dispatch<SetStateAction<boolean>>;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);